var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: _vm.$style.container
  }, [_c('div', {
    domProps: {
      "textContent": _vm._s(_vm.displayPaymentData)
    }
  }), _vm.isExternalPaymentMethod ? _c('div', {
    class: _vm.$style.description,
    domProps: {
      "textContent": _vm._s(_vm.$t('money.sent.to.your.wallet'))
    }
  }) : _vm._e()]);
}
var staticRenderFns = []

export { render, staticRenderFns }